
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ourservices",
      function () {
        return require("private-next-pages/ourservices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ourservices"])
      });
    }
  